import script from "./XImg.vue?vue&type=script&setup=true&lang=ts"
export * from "./XImg.vue?vue&type=script&setup=true&lang=ts"

import "./XImg.vue?vue&type=style&index=0&id=f461ed1c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f461ed1c"]])

export default __exports__